export const PROJECT_CATEGORIES = [
  {
    slug: "office",
    name: "Office Installations",
    image: "/images/services/office-installations.jpg",
    projects: [
      { title: "Corporate Office IT & Security Fit-out", location: "Infopark, Kochi", description: "Complete networking, CCTV and access control for a 60-seat office." },
      { title: "Head Office Infrastructure Upgrade", location: "Kaloor, Ernakulam", image: "/images/services/epabx-intercom.jpg", description: "EPABX, UPS and structured cabling refresh with zero downtime." },
    ],
  },
  {
    slug: "apartment",
    name: "Apartment Installations",
    image: "/images/services/apartment-installations.jpg",
    projects: [
      { title: "Gated Community Surveillance", location: "Vyttila, Kochi", description: "32-camera CCTV with video door phones across four towers." },
      { title: "Apartment Access & Intercom", location: "Kazhakkoottam, Thiruvananthapuram", image: "/images/services/video-door-phones.jpg", description: "Biometric lobby access with flat-wise intercom." },
    ],
  },
  {
    slug: "cctv",
    name: "CCTV Projects",
    image: "/images/services/cctv-solutions.jpg",
    projects: [
      { title: "Retail Chain Surveillance Rollout", location: "Thrissur", description: "HD IP cameras with central monitoring across six outlets." },
      { title: "Campus Perimeter Watch", location: "Kottayam", image: "/images/services/cctv-projects-2.jpg", description: "Night-vision perimeter coverage with 30-day recording." },
    ],
  },
  {
    slug: "access-control",
    name: "Access Control Projects",
    image: "/images/services/access-control-systems.jpg",
    projects: [
      { title: "Hospital Ward Access Control", location: "Ernakulam", description: "Card and biometric access across 14 restricted zones." },
      { title: "Factory Gate & Turnstile Automation", location: "Palakkad", image: "/images/services/biometric-attendance.jpg", description: "Turnstiles with face recognition for 400+ staff." },
    ],
  },
  {
    slug: "networking",
    name: "Networking Projects",
    image: "/images/services/networking-solutions.jpg",
    projects: [
      { title: "Hotel Wi-Fi & LAN Overhaul", location: "Munnar", description: "Property-wide Wi-Fi 6 with guest captive portal." },
      { title: "Warehouse Network Backbone", location: "Aluva", image: "/images/services/structured-cabling.jpg", description: "Fibre backbone and rack build for a 40,000 sq ft facility." },
    ],
  },
  {
    slug: "fire-alarm",
    name: "Fire Alarm Projects",
    image: "/images/services/fire-alarm-systems.jpg",
    projects: [
      { title: "Convention Centre Fire Detection", location: "Kozhikode", description: "Addressable fire alarm with PA evacuation interface." },
      { title: "Hostel Fire Safety Compliance", location: "Kochi", image: "/images/services/fire-alarm-projects-2.jpg", description: "Smoke detection and hooters across five floors, fully certified." },
    ],
  },
];
